/* 
 * 用户管理模块
 */

// 保存
export function save() {
  return {
    url: 'user/save',
    type: 'post',
    data: {
      "code": 200,
      "msg": null,
      "data": 1
    }
  }
}
// 批量删除
export function batchDelete() {
  return {
    url: 'user/delete',
    type: 'post',
    data: {
      "code": 200,
      "msg": null,
      "data": 1
    }
  }
}
// 分页查询
export function findPage(params) {
  let findPageData = {
    "code": 200,
    "msg": null,
    "data": {
      "pageNum": 1,
      "pageSize": 9,
      "totalSize": 12,
      "totalPages": 2,
      "content": [
        {
          "id": 1,
          "createBy": "admin",
          "createTime": "2018-08-14T03:11:11.000+0000",
          "lastUpdateBy": "admin",
          "lastUpdateTime": "2018-08-14T03:11:11.000+0000",
          "name": "admin",
          "nickName": "超管",
          "avatar": null,
          "password": "bd1718f058d8a02468134432b8656a86",
          "salt": "YzcmCZNvbXocrsz9dm8e",
          "email": "admin@qq.com",
          "mobile": "13612345678",
          "status": 1,
          "deptId": 4,
          "delFlag": 0,
          "deptName": "同望",
          "roleNames": "超级管理员",
          "userRoles": [
            {
              "id": 1,
              "createBy": null,
              "createTime": null,
              "lastUpdateBy": null,
              "lastUpdateTime": null,
              "userId": 1,
              "roleId": 1
            }
          ]
        },
        {
          "id": 22,
          "createBy": "admin",
          "createTime": "2018-09-23T11:43:00.000+0000",
          "lastUpdateBy": "admin",
          "lastUpdateTime": "2019-01-10T03:41:13.000+0000",
          "name": "liubei",
          "nickName": "chenhs",
          "avatar": null,
          "password": "fd80ebd493a655608dc893a9f897d845",
          "salt": "YzcmCZNvbXocrsz9dm8e",
          "email": "test@qq.com",
          "mobile": "13889700023",
          "status": 1,
          "deptId": 7,
          "delFlag": 0,
          "deptName": "同望",
          "roleNames": "开发",
          "userRoles": [
            {
              "id": 80,
              "createBy": null,
              "createTime": null,
              "lastUpdateBy": null,
              "lastUpdateTime": null,
              "userId": 22,
              "roleId": 2
            }
          ]
        }
      ]
    }
  }
  return {
    url: 'user/findPage',
    type: 'post',
    data: findPageData
  }
}
// 查找用户的菜单权限标识集合
export function findPermissions() {
  let permsData = {
    "code": 200,
    "msg": null,
    "data": [
      null,
      "sys:user:view",
      "sys:menu:delete",
      "sys:dept:edit",
      "sys:dict:edit",
      "sys:dict:delete",
      "sys:menu:add",
      "sys:user:add",
      "sys:log:view",
      "sys:dept:delete",
      "sys:role:edit",
      "sys:role:view",
      "sys:dict:view",
      "sys:user:edit",
      "sys:user:delete",
      "sys:dept:view",
      "sys:dept:add",
      "sys:role:delete",
      "sys:menu:view",
      "sys:menu:edit",
      "sys:dict:add",
      "sys:role:add"
    ]
  }
  return {
    url: 'user/findPermissions',
    type: 'get',
    data: permsData
  }
}
// 根据用户名查找
export function findByName(params) {
  let findPageData = {
    "code": 200,
    "msg": null,
    "data": {
      "id": 1,
      "createBy": "admin",
      "createTime": "2021-06-30",
      "lastUpdateBy": "admin",
      "lastUpdateTime": "2021-06-30",
      "name": "admin",
      "nickName": "郭俊威",
      "avatar": null,
      "password": "bd1718f058d8a02468134432b8656a86",
      "salt": "YzcmCZNvbXocrsz9dm8e",
      "email": "admin@qq.com",
      "mobile": "13612345678",
      "status": 1,
      "deptId": 4,
      "delFlag": 0,
      "deptName": "同望",
      "roleNames": "管理员",
      "userRoles": [
        {
          "id": 1,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "userId": 1,
          "roleId": 1
        }
      ]
    }
  }
  return {
    url: 'user/findByName',
    type: 'get',
    data: findPageData
  }
}
// 更新用户密码
export function updatePassword(params) {
  let findPageData = { "code": 200, "msg": null, "data": 1 }
  return {
    url: 'user/updatePassword',
    type: 'get',
    data: findPageData
  }
}


// WEBPACK FOOTER //
// ./src/mock/modules/user.js